import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { AlertsConfig, AlertsPeriod, Project, User } from '../../_models/index';
import {
  AlertService,
  AuthenticationService,
  NotificationService,
  ProjectService,
  TenantService,
  UserService,
} from '../../_services/index';
import { LoginHelper, Role } from '../../helpers';

@Component({
    standalone: false,
  selector: 'alerts',
  templateUrl: 'alerts.component.html',
  styleUrls: ['./alerts.component.scss'],
})
export class AlertsComponent implements OnInit {
  loading = false;
  currentUser: User;
  defaultStartDate = new Date();
  defaultEndDate = new Date();
  projects: Project[];

  model: AlertsConfig = new AlertsConfig();
  //newModel: AlertsConfig = new AlertsConfig();
  periods: any[] = [
    { name: 'None', value: 0 },
    { name: 'Daily', value: 1 },
    { name: 'Weekly', value: 2 },
    { name: 'Monthly', value: 3 },
    { name: 'Yearly', value: 4 },
  ];
  daysOfWeek: any[];
  months: any[];
  daysInMonth: any[];
  individual = [{ title: 'Upcoming Due', key: 'general' }];
  individualMap: any;
  additionals = ['survey', 'awareness'];
  constructor(
    public router: Router,
    public userService: UserService,
    public alertService: AlertService,
    public notificationService: NotificationService,
    public tenantService: TenantService,
    public projectService: ProjectService,
    public authenticationService: AuthenticationService
  ) {
    this.daysOfWeek = [
      { name: 'Sunday', value: 1 },
      { name: 'Monday', value: 2 },
      { name: 'Tuesday', value: 3 },
      { name: 'Wednesday', value: 4 },
      { name: 'Thursday', value: 5 },
      { name: 'Friday', value: 6 },
      { name: 'Saturday', value: 7 },
    ];

    this.months = [
      { name: 'January', value: 1 },
      { name: 'February', value: 2 },
      { name: 'March', value: 3 },
      { name: 'April', value: 4 },
      { name: 'May', value: 5 },
      { name: 'June', value: 6 },
      { name: 'July', value: 7 },
      { name: 'August', value: 8 },
      { name: 'September', value: 9 },
      { name: 'October', value: 10 },
      { name: 'November', value: 11 },
      { name: 'December', value: 12 },
    ];

    this.daysInMonth = [];
    for (let index = 1; index < 32; index++) {
      this.daysInMonth.push({ name: index.toString(), value: index });
    }
  }

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    forkJoin(
      this.tenantService.getCurrent(),
      this.notificationService.getAlertsConfiguration(),
      this.projectService.getAllShort()
    ).subscribe(
      (datas) => {
        let i;
        const p = datas[0];
        const data = datas[1];
        this.projects = datas[2];
        if (p && p.isPdfReportsEnabled && (this.currentUser.role & Role.Engineer) == 0) {
          this.individual.push({ title: 'POAM PDF', key: 'poam' });
        }
        if (p && p.isPdfReportsEnabled) {
          this.individual.push({ title: 'Overdue PDF', key: 'overdue' });
        }
        this.individual.push({ title: 'Evidence Inspection', key: 'evidenceinspection' });
        this.model = <AlertsConfig>data;
        this.individualMap = {};
        for (i = 0; i < this.individual.length; i++) {
          this.individualMap[this.individual[i].key] = (
            (data || {}).individualSettings || []
          ).find((t) => t.key == this.individual[i].key) || {
            key: this.individual[i].key,
            period: 0,
          };
          this.initAlerts(this.individualMap[this.individual[i].key]);
          this.individualMap[this.individual[i].key].projectStatuses =
            this.projects.map((p) => ({
              projectId: p.projectId,
              name: p.name,
              checked:
                (
                  this.individualMap[this.individual[i].key].projectIds || []
                ).indexOf(p.projectId) >= 0,
            }));
        }

        for (i = 0; i < this.additionals.length; i++) {
          const additional = this.additionals[i];
          this.individualMap[additional] = (
            (data || {}).individualSettings || []
          ).find((t) => t.key == additional) || {
            key: additional,
            enabled: true,
          };
        }
        if (
          this.currentUser.role == Role.Survey ||
          this.currentUser.role == Role.Training
        ) {
          this.individual = [];
        }

        this.initAlerts(this.model);
        console.log(this.individualMap);
      },
      (error) => {
        this.model = new AlertsConfig();
        this.model.daysOfMonth = [Math.min(new Date().getDate(), 28)];
        this.model.startDateTime = new Date();
        const endDate = new Date();
        endDate.setFullYear(endDate.getFullYear() + 1);
        this.model.endDateTime = endDate;
        this.model.period = AlertsPeriod.Monthly;
        this.initAlerts(this.model);
        this.individualMap = {};
        for (let i = 0; i < this.individual.length; i++) {
          this.individualMap[this.individual[i].key] = {
            key: this.individual[i].key,
          };
          this.initAlerts(this.individualMap[this.individual[i].key]);
        }
      }
    );

    document.body.addEventListener('click', (e) => {
      if (
        !(
          (<any>e.target).name == 'startTime' ||
          (<any>e.target).closest('.time-picker')
        )
      ) {
        this.model.timeShown = false;
        for (let i = 0; i < this.individual.length; i++) {
          if (this.individualMap) {
            this.individualMap[this.individual[i].key].timeShown = false;
          }
        }
      }
    });
  }

  public initAlerts(model: any) {
    let tommorowDayTime;
    if (model.period == 0) {
      const dateTimeNow = new Date(Date.now());
      tommorowDayTime = new Date(Date.now());
      tommorowDayTime.setDate(dateTimeNow.getDate() + 1);

      model.startDateTime = dateTimeNow;
      model.endDateTime = tommorowDayTime;
      model.localHours = new Date().getHours();
      model.localMinutes = new Date().getMinutes();
      model.hours =
        (model.localHours +
          Math.floor(new Date().getTimezoneOffset() / 60) +
          24) %
        24;
      model.minutes =
        (model.localMinutes +
          Math.floor(new Date().getTimezoneOffset() % 60) +
          60) %
        60;
      this.updateTime(model);
    } else {
      tommorowDayTime = new Date(Date.now());
      tommorowDayTime.setDate(tommorowDayTime.getDate() + 1);
      model.startDateTime = new Date(model.startDateTime || new Date());
      //model.endDateTime = new Date(tommorowDayTime);
      model.localHours =
        (model.hours - Math.floor(new Date().getTimezoneOffset() / 60) + 24) %
        24;
      model.localMinutes =
        (model.minutes - Math.floor(new Date().getTimezoneOffset() % 60) + 60) %
        60;
      this.updateTime(model);
    }
  }

  onSave() {
    let i;
    this.alertService.clear();

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    if (!this.model.startDateTime || !this.model.endDateTime) {
      this.alertService.error('Please fill required fields');

      return;
    }

    if (this.model.startDateTime >= this.model.endDateTime) {
      this.alertService.error('End date should be greater than start date');

      return;
    }

    this.model.startDateTime.setSeconds(0);

    if (
      this.model.period == AlertsPeriod.Weekly &&
      (this.model.daysOfWeek == null || this.model.daysOfWeek.length == 0)
    ) {
      this.alertService.error('Please fill required fields');
      return;
    }

    if (
      this.model.period == AlertsPeriod.Monthly &&
      (this.model.daysOfMonth == null || this.model.daysOfMonth.length == 0)
    ) {
      this.alertService.error('Please fill required fields');
      return;
    }
    if (
      this.model.period == AlertsPeriod.Yearly &&
      (this.model.daysOfMonth == null ||
        this.model.daysOfMonth.length == 0 ||
        this.model.months == null ||
        this.model.months.length == 0)
    ) {
      this.alertService.error('Please fill required fields');
      return;
    }

    this.model.startDateTime.setHours(this.model.hours, this.model.minutes);

    this.model.individualSettings = [];
    for (i = 0; i < this.individual.length; i++) {
      this.individualMap[this.individual[i].key].projectIds =
        this.individualMap[this.individual[i].key].projectStatuses
          .filter((s) => s.checked)
          .map((s) => s.projectId);
      this.model.individualSettings.push(
        this.individualMap[this.individual[i].key]
      );
    }
    for (i = 0; i < this.additionals.length; i++) {
      this.model.individualSettings.push(
        this.individualMap[this.additionals[i]]
      );
    }

    this.notificationService.saveAlertsConfiguration(this.model).subscribe(
      (_) => {
        this.alertService.success('The alerts configuration was saved.', true);
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        const message = 'An error occurred while saving alerts configuration.';
        this.alertService.error(message);
      }
    );
  }

  checkTime(config) {
    const split = config.startTime.split(':');
    config.localHours = parseInt(split[0]);
    config.localMinutes = parseInt(split[1]);
    config.hours =
      (config.localHours +
        Math.floor(new Date().getTimezoneOffset() / 60) +
        24) %
      24;
    config.minutes =
      (config.localMinutes + (new Date().getTimezoneOffset() % 60) + 60) % 60;
    this.updateTime(config);
  }

  updateTime(config) {
    config.hours =
      (config.localHours +
        Math.floor(new Date().getTimezoneOffset() / 60) +
        24) %
      24;
    config.minutes =
      (config.localMinutes +
        Math.floor(new Date().getTimezoneOffset() % 60) +
        60) %
      60;
    config.startTime =
      (config.localHours < 10 ? '0' : '') +
      config.localHours.toString(10) +
      ':' +
      (config.localMinutes < 10 ? '0' : '') +
      config.localMinutes.toString(10);
  }

  setNow(config) {
    config.localHours = new Date().getHours();
    config.localMinutes = new Date().getMinutes();
    config.hours =
      (new Date().getHours() -
        Math.floor(new Date().getTimezoneOffset() / 60) +
        24) %
      24;
    config.minutes =
      (new Date().getMinutes() -
        Math.floor(new Date().getTimezoneOffset() % 60) +
        60) %
      60;
    this.updateTime(config);
  }
}
